"use strict";

/* ============================================================================
   Hodalump — Merkliste
   ============================================================================
   Aenderungen am Original (29.08.2026):

   1. FEHLER BEHOBEN: data-id war fest verdrahtet.
      Original: box.insertAdjacentHTML(..., `<button ... data-id="8557873430679">`)
      Jeder Entfernen-Knopf trug dieselbe fremde Produkt-ID. Beim Klick lief
      damit indexOf(id) auf -1, und splice(-1, 1) entfernt das LETZTE Element
      der Liste statt des gemeinten. Die angeklickte Karte verschwand zwar aus
      der Ansicht, im Speicher wurde aber das falsche Produkt geloescht — nach
      einem Neuladen war der zuletzt gemerkte Artikel weg und der angeklickte
      wieder da. Die ID kommt jetzt aus dem .addwishlist-Knopf der Karte.

   2. Herz statt Kreuz. Das Theme blendete auf der Merkliste das Merken-Herz aus
      (display:none) und setzte stattdessen ein schwarzes 36px-Kreuz. Jetzt
      dasselbe gefuellte Herz wie auf den Produktkarten, in Rot — die Optik ist
      damit ueberall gleich, und ein gefuelltes Herz sagt „gemerkt" deutlicher
      als ein Kreuz „entfernen".

   3. Liste wird bei jedem Klick frisch aus localStorage gelesen. Die
      Modulvariable wlItems wurde beim Laden der Datei EINMAL gesetzt; wer in
      einem zweiten Tab etwas merkt, arbeitete sonst auf einem veralteten Stand
      und ueberschrieb ihn.

   4. Fehlt ein Element in der Liste, wird nichts entfernt. Vorher konnte
      splice(-1, 1) blind zuschlagen.
   ============================================================================ */

var wl = 'at_wishlist';

function hdListeLesen() {
  try { return JSON.parse(localStorage.getItem(wl)) || []; }
  catch (e) { return []; }
}

class WishlistItems extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getWlProducts(hdListeLesen());
  }
  getWlProducts(p){
      var query = "",
        ajaxURL = "";

    if(p && p.length > 0) {
      query = p.join("%20OR%20id:");
      ajaxURL = `?q=id:${query}`;
    }

    fetch(`${this.dataset.url}${ajaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const wlProducts = html.querySelector("#collection-products");
        const wlDiv = document.querySelector("#wishlist");
        if (wlProducts && wlProducts.innerHTML.trim().length) {
          wlDiv.innerHTML = wlProducts.innerHTML;
          document.querySelector(".wlnull").classList.add('hide');
          this.removeItem();
        }
      })
      .finally(() => {
        checkWishlist();
        initializeScrollAnimationTrigger();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeItem(){
    var products = this.querySelectorAll(".grid-content");
    products.forEach((box) => {
        /* Die Produkt-ID steht am Merken-Knopf, den die Produktkarte selbst
           mitbringt. Ohne ihn laesst sich nichts sauber entfernen — dann wird
           gar kein Knopf gesetzt, statt einen mit falscher ID zu bauen. */
        var quelle = box.querySelector(".addwishlist");
        var id = quelle ? quelle.dataset.id : "";
        if (!id) { return; }

        box.insertAdjacentHTML("beforeend",
          `<button type="button" class="grid-button pr remove-item hd-merk-weg" data-id="${id}" aria-label="Aus der Merkliste entfernen"><span class="txt"><svg class="at-icon wishicon added"><use xlink:href="#icon-wishlist-add"></use></svg></span><span class="wish-txt hide" aria-hidden="true"></span><svg class="at-icon at-spin"><use xlink:href="#icon-loading"></use></svg></button>`);
    });

    var buttons = this.querySelectorAll(".remove-item");
    buttons.forEach((btn) => {
        var wraper = btn.closest('.gitem');
      btn.addEventListener("click", function(){
        const id = this.dataset.id;
        var liste = hdListeLesen();
        const index = liste.indexOf(id);
        /* Nur entfernen, wenn wirklich gefunden. splice(-1, 1) wuerde sonst
           das letzte Element treffen — genau der Fehler von vorher. */
        if (index !== -1) {
          liste.splice(index, 1);
          localStorage.setItem(wl, JSON.stringify(liste));
        }
        if (wraper) { wraper.remove(); }
        checkWishlist();

        /* War es das letzte Produkt, gehoert der Leer-Hinweis wieder her. */
        var rest = document.querySelectorAll("#wishlist .grid-content").length;
        var leer = document.querySelector(".wlnull");
        if (rest === 0 && leer) { leer.classList.remove('hide'); }
      });
    });
  }
}
customElements.define("wishlist-items", WishlistItems);